import { render, staticRenderFns } from "./modalityCascader.vue?vue&type=template&id=09aa766b"
import script from "./modalityCascader.vue?vue&type=script&lang=js"
export * from "./modalityCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports